export default function TermsAndConditionsSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="space-y-6 max-w-3xl py-8 text-left">
        <div className="rounded-md bg-gray-50 p-4 md:p-6">
          <div className="mb-4">
            <div className="h-5 w-24 bg-gray-200 rounded mb-2"></div>
            <div className="h-64 w-full bg-gray-200 rounded"></div>
          </div>
          <div className="mt-6 flex justify-end">
            <div className="h-10 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
